const featureFlagsConstants = {
	SET_FEATURE_FLAGS: 'SET_FEATURE_FLAGS',
	UPDATE_FEATURE_FLAG: 'UPDATE_FEATURE_FLAG',
};

export default featureFlagsConstants;
